import { theme } from "../../../theme/colors";

/** @typedef {'primary' | 'secondary' | 'tertiary' | 'pill'} CivixButtonVariant */
/** @typedef {'sm' | 'md' | 'lg'} CivixButtonSize */

export const BUTTON_SIZES = {
  sm: {
    minHeight: 40,
    px: 3,
    py: 1,
    fontSize: "0.875rem",
    borderRadius: "12px",
  },
  md: {
    minHeight: 48,
    px: 4,
    py: 1.25,
    fontSize: "1rem",
    borderRadius: "16px",
  },
  lg: {
    minHeight: 56,
    px: 5,
    py: 1.5,
    fontSize: "1.125rem",
    borderRadius: "16px",
  },
};

/**
 * Primary = glassy emerald CTA (baseline from Join /compare plans).
 * Secondary = outlined glass. Tertiary = text-only.
 */
export const BUTTON_VARIANTS = {
  primary: {
    glass: true,
    color: "#ffffff",
    bgcolor: "#047857",
    border: "1px solid rgba(255,255,255,0.15)",
    boxShadow: "0 6px 20px rgba(4, 120, 87, 0.25), inset 0 1px 1px rgba(255,255,255,0.4)",
    boxShadowHover:
      "0 10px 32px rgba(4, 120, 87, 0.4), inset 0 1px 2px rgba(255,255,255,0.6)",
    borderHover: "rgba(255,255,255,0.3)",
    glassOverlay:
      "linear-gradient(180deg, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0) 40%, rgba(0,0,0,0.1) 100%)",
    shader: {
      dark: [0.012, 0.42, 0.3],
      mid: [0.016, 0.47, 0.34],
      light: [0.024, 0.5, 0.37],
      // Barely lighter than primary #047857 — subtle sweep highlight
      sheen: [0.03, 0.52, 0.39],
      holoTint: [0.022, 0.49, 0.36],
    },
  },
  secondary: {
    glass: false,
    color: "var(--black-color)",
    bgcolor: "rgba(255, 255, 255, 0.85)",
    border: "1px solid var(--join-border-muted, #e4e4e4)",
    boxShadow: theme.joinShadowCard,
    boxShadowHover: theme.joinShadowElevated,
    borderHover: "#cbd5e1",
    glassOverlay: null,
    shader: null,
    "&:hover": {
      bgcolor: "rgba(248, 250, 252, 0.95)",
    },
  },
  tertiary: {
    glass: false,
    color: theme.primary,
    bgcolor: "transparent",
    border: "1px solid transparent",
    boxShadow: "none",
    boxShadowHover: "none",
    borderHover: "transparent",
    glassOverlay: null,
    shader: null,
    "&:hover": {
      bgcolor: "rgba(4, 120, 87, 0.06)",
      color: theme.primaryHover,
    },
  },
  pill: {
    glass: false,
    color: "#ffffff",
    bgcolor: "#047857",
    background: "linear-gradient(160deg, #059669 0%, #047857 55%, #065f46 100%)",
    border: "1px solid transparent",
    boxShadow: "0 1px 4px rgba(4, 120, 87, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.18)",
    boxShadowHover:
      "0 6px 20px rgba(4, 120, 87, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.18)",
    borderHover: "transparent",
    glassOverlay: null,
    shader: null,
    "&:hover": {
      background: "linear-gradient(160deg, #059669 0%, #047857 55%, #065f46 100%)",
    },
  },
};

export function prefersReducedMotion() {
  if (typeof window === "undefined") return true;
  const query = window.matchMedia?.("(prefers-reduced-motion: reduce)");
  if (!query) return false;
  return query.matches;
}
